<div class="flex flex-col gap-4">
  <div>
    @if (group()._id) {
      <div class="text-muted-color">{{ group()._id }}</div>
    }

    <form [formGroup]="groupForm">
      <p-floatlabel variant="on">
        <input
          pInputText
          formControlName="name"
          fluid
          [disabled]="editingDisabled()"
          autocomplete="off"
        />
        <label>{{ 'internal.inventory.groupEdit.name' | translate }}</label>
      </p-floatlabel>
    </form>
  </div>

  <barcode-scanner-search-field (onCode)="codeScanned($event)"></barcode-scanner-search-field>

  <div class="flex flex-col gap-2 bg-neutral-800 rounded-sm p-2">
    <div class="flex flex-row justify-between items-center">
      <div class="text-lg font-bold">{{ 'internal.inventory.items' | translate }}</div>
    </div>

    <div class="h-1 bg-neutral-900"></div>

    <div class="flex flex-col gap-2">
      @if (loadingGroup()) {
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
      } @else {
        @for (types of itemTypes(); track types) {
          <div class="item pt-2 rounded-sm" [class.shaking]="typeShaking(types._id)" #typeElements>
            <div
              class="flex flex-row items-center gap-2 cursor-pointer"
              (click)="toggleCollapse(types._id)"
            >
              <mat-icon color="white">
                {{ collapsedTypes()[types._id] ? 'expand_more' : 'expand_less' }}
              </mat-icon>
              <span class="item-count">{{ itemTypesCount()[types._id] }}x </span>
              <span class="font-semibold">{{ types.name }}</span>
              @if (types.additionalInfo) {
                <div class="ml-4 text-sm text-muted-color">{{ types.additionalInfo }}</div>
              }
            </div>
            <div
              class="instance-list flex flex-col mt-2 ml-4"
              [class.collapsed]="collapsedTypes()[types._id]"
            >
              @for (instance of itemFilter(types._id); track instance) {
                <div
                  class="instance flex flex-row items-center h-9 rounded-sm"
                  [class.deleted]="instanceDeleted(types._id, instance.instanceid)"
                  [class.shaking]="instanceShaking(types._id, instance.instanceid)"
                  [attr.id]="instance.itemid + '-' + instance.instanceid"
                  #instanceElements
                >
                  <div class="ml-2 text-base font-semibold">{{ types.name }}</div>
                  <div class="ml-4 text-sm text-muted-color">{{ instance.instanceid }}</div>
                  <div class="ml-4">
                    {{
                      (instanceBooked(types._id, instance.instanceid)
                        ? 'internal.inventory.notReturned'
                        : ''
                      ) | translate
                    }}
                  </div>
                  @if (instanceDeleted(types._id, instance.instanceid)) {
                    <div class="ml-4">{{ 'internal.inventory.deleted' | translate }}</div>
                  }
                  <div class="ml-auto flex flex-row justify-end items-center gap-2">
                    <p-button
                      [pt]="{ root: { style: { padding: '4px' } } }"
                      [rounded]="true"
                      [text]="true"
                      (onClick)="selectItem(types, [instance.instanceid])"
                    >
                      <mat-icon color="white"> visibility </mat-icon>
                    </p-button>
                    <p-button
                      [pt]="{ root: { style: { padding: '4px' } } }"
                      [rounded]="true"
                      [text]="true"
                      severity="danger"
                      (onClick)="removeItem(types._id, instance.instanceid)"
                    >
                      <mat-icon color="white"> delete </mat-icon>
                    </p-button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  @if (group()._id) {
    <p-button
      [label]="'general.delete' | translate"
      [disabled]="deletionDisabled()"
      severity="danger"
      (onClick)="deleteGroup()"
    />
  }
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
  <p-button
    [label]="'general.save' | translate"
    [disabled]="editingDisabled() || groupForm.invalid"
    severity="primary"
    (onClick)="saveGroup()"
  />
</div>
